import ReadOnlyScaling from './ReadOnlyScaling'

export default ReadOnlyScaling
